export default function TestimonialSection() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24 px-6 md:px-12">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-10 lg:gap-16">
        <div className="w-full lg:w-[58%] flex flex-col justify-center">
          <span className="inline-flex items-center gap-2 text-xs font-label text-accent-600 uppercase tracking-wider mb-8">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            Trusted Review
          </span>

          <blockquote className="text-2xl md:text-3xl lg:text-4xl font-heading font-medium italic text-foreground-900 leading-relaxed mb-8 relative">
            <span className="text-5xl md:text-6xl text-accent-300 font-heading leading-none absolute -top-4 -left-2 select-none">&ldquo;</span>
            <span className="relative z-10 pl-6 md:pl-8 block">
              YOYBUY Spreadsheet сэкономил мне кучу времени! Больше не нужно вручную считать заказы — всё в одной удобной таблице. Рекомендую всем, кто покупает через агентов.
            </span>
          </blockquote>

          <div className="flex items-center gap-3 pl-6 md:pl-8">
            <div className="w-10 h-10 rounded-full bg-background-200 flex items-center justify-center">
              <i className="ri-user-line text-foreground-500"></i>
            </div>
            <div>
              <div className="text-sm font-semibold text-foreground-900">Anna K.</div>
              <div className="flex items-center gap-1.5 text-xs text-accent-600">
                <i className="ri-verified-badge-fill text-accent-500"></i>
                Verified Buyer
              </div>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-[42%] flex items-center justify-center">
          <div className="w-full max-w-sm aspect-[3/4] rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20portrait%20of%20young%20European%20woman%20profile%20view%20looking%20upward%20with%20confidence%20natural%20light%20from%20window%20clean%20white%20background%20soft%20shadows%20editorial%20black%20and%20white%20photography%20minimalist%20style%20fashion%20portrait%20high%20key%20lighting%20airy%20atmosphere&width=500&height=700&seq=yoybuy-testimonial-08&orientation=portrait"
              alt="Отзыв о YOYBUY Spreadsheet"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}